import { render, staticRenderFns } from "./BajasCobranzaFilters.vue?vue&type=template&id=b0b3485c&"
import script from "./BajasCobranzaFilters.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports